import { reportUtils } from "../../report-utils";
import { ColumnData, DynamicTableOptions } from '../../../shared/interfaces-classes/index';
import { dynamicTable } from "../../../shared/exports";
export var afirm = {
    type: '',
    report: {},
    useNameAndDescHeaders: false,
    // courseTypeMap: {
    // 	type1: [
    // 		'http://stelar-afirm-mod0'
    // 	],
    // 	type2: [
    // 		'http://stelar-afirm-mod1',
    // 		'http://stelar-afirm-mod2',
    // 	],
    // },
    courseTypeMap: {
        'http://afirm-intro-to-autism': {
            type: 'type1',
        },
        'http://stelar-afirm-mod0': {
            type: 'type1',
        },
        'http://stelar-afirm-mod1': {
            type: 'type2',
            totals: {
                colHeaderSuffixes: [
                    '',
                    '',
                    '',
                    '(12)',
                    '(12)',
                    '(12)',
                    '(6)',
                    '(4)',
                    '(4)',
                ]
            }
        },
        'http://stelar-afirm-mod2': {
            type: 'type2',
            totals: {
                colHeaderSuffixes: [
                    '',
                    '',
                    '',
                    '(10)',
                    '(16)',
                    '(8)',
                    '(9)',
                    '(10)',
                    '(4)', // 'Monitor - Next Steps',
                ]
            }
        },
        'http://stelar-afirm-mod3': {
            type: 'type2',
            totals: {
                colHeaderSuffixes: [
                    '',
                    '',
                    '',
                    '(4)',
                    '(10)',
                    '(6)',
                    '(22)',
                    '(8)',
                    '(2)',
                ]
            }
        },
        'http://stelar-afirm-mod4': {
            type: 'type2',
            totals: {
                colHeaderSuffixes: [
                    '',
                    '',
                    '',
                    '(8)',
                    '(13)',
                    '(10)',
                    '(32)',
                    '(15)',
                    '(7)',
                ]
            }
        },
        // Is actually now Mod 5: Peer Interaction
        'http://stelar-afirm-mod6': {
            type: 'type2',
            totals: {
                colHeaderSuffixes: [
                    '',
                    '',
                    '',
                    '(13)',
                    '(10)',
                    '(8)',
                    '(16)',
                    '(6)',
                    '(3)',
                ]
            }
        },
    },
    colHeaders: {
        type1: {
            totals: [
                'UID',
                'Module Completed Date',
                'Module Completed Time',
                'Max Score',
                'Pre-Student Raw Score',
                'Pre-Teacher Raw Score',
                'Pre-Task Raw Score',
                'Post-Student Raw Score',
                'Post-Teacher Raw Score',
                'Post-Task Raw Score',
            ],
            allValues: [], // auto-generated
        },
        type2: {
            totals: [
                'UID',
                'Module Completed Date',
                'Module Completed Time',
                'Plan Total - General Info',
                'Plan Total - EBP Specific',
                'Use Total - Rules',
                'Use Total - Steps',
                'Monitor - Data collection',
                'Monitor - Next Steps',
            ],
            allValues: [], // auto-generated
        },
    },
    colDataStructure: {
        type1: {
            totals: /** @class */ (function () {
                function User() {
                    this.uid = '';
                    this.completedAtDate = '';
                    this.completedAtTime = '';
                    this.maxScore = new ColumnData();
                    this.score_preStudent = new ColumnData();
                    this.score_preTeacher = new ColumnData();
                    this.score_preTask = new ColumnData();
                    this.score_postStudent = new ColumnData();
                    this.score_postTeacher = new ColumnData();
                    this.score_postTask = new ColumnData();
                }
                return User;
            }()),
            allValues: {}, // auto-generated
        },
        type2: {
            totals: /** @class */ (function () {
                function User() {
                    this.uid = '';
                    this.completedAtDate = '';
                    this.completedAtTime = '';
                    this.score_planGeneral = new ColumnData();
                    this.score_planEbp = new ColumnData();
                    this.score_useRules = new ColumnData();
                    this.score_useSteps = new ColumnData();
                    this.score_monitorData = new ColumnData();
                    this.score_monitorSteps = new ColumnData();
                }
                return User;
            }()),
            allValues: {}, // auto-generated
        },
    },
    // extract to common?
    init: function (stmts) {
        var _this = this;
        var type = this.type;
        return new Promise(function (resolve, reject) {
            var invalid = !_this[type];
            if (invalid) {
                alert('Custom report not available yet; showing standard report.');
                reject('invalid');
            }
            else {
                var tableData = _this[type](stmts);
                resolve(tableData);
            }
        });
    },
    // createColumnHeaders(standardHeaders: any[] = []): any[] {
    createColumnHeaders: function () {
        var _a = this, colHeaders = _a.colHeaders, report = _a.report, courseTypeMap = _a.courseTypeMap;
        var id = report.id, type = report.type;
        var modifications = courseTypeMap[id][type];
        var headerSuffixes = modifications ? modifications.colHeaderSuffixes || null : null;
        var courseStructureType = this.getCourseStructureType(id);
        var baseHeaders = colHeaders[courseStructureType][type];
        if (headerSuffixes) {
            return baseHeaders.slice().map(function (header, index) {
                return header + " " + headerSuffixes[index];
            });
        }
        else {
            return baseHeaders;
        }
    },
    createColumnStructure: function () {
        var _a = this, colDataStructure = _a.colDataStructure, report = _a.report, type = _a.type;
        var courseStructureType = this.getCourseStructureType(report.id);
        console.log('courseStructureType:', courseStructureType);
        try {
            var columnMap = {};
            var columnStructureArray = [];
            var CustomColumnData = colDataStructure[courseStructureType][type];
            if (!CustomColumnData) {
                return [];
            }
            if (type === 'allValues') {
                columnMap = CustomColumnData;
            }
            else {
                columnMap = new CustomColumnData();
            }
            columnStructureArray = Object.keys(columnMap);
            return columnStructureArray.map(function (key) {
                return { data: key };
            });
        }
        catch (error) {
            console.error('Custom column structure error:', error);
        }
    },
    getxAPISearchValues: function (search) {
        // if (afirm.type === 'allValues') {
        // 	const uid = $('#uid').val() || '';
        // 	if (!uid) {
        // 		alert('Please enter a user ID.');
        // 		return false;
        // 	}
        // 	search.agent = {
        // 		account: {
        // 			name: uid,
        // 			homePage: 'http://fpg.unc.edu',
        // 		}
        // 	};
        // }
        afirm.useNameAndDescHeaders = $('#showDescHeader')[0].checked;
        return search;
    },
    ui: {
        init: function () {
            this.updateFilters();
        },
        updateFilters: function () {
            if (afirm.type === 'allValues') {
                $('.all-values-options').show();
                // 	$('.standard.filters').addClass('hidden');
                // 	$('.custom.filters').removeClass('hidden');
                // 	$('.user-filter').removeClass('hidden');
                // 	$('.user-filter-uid').removeClass('hidden');
            }
            else {
                $('.all-values-options').hide();
            }
        },
    },
    totals: function (stmts) {
        var _this = this;
        var userMap = {};
        var report = afirm.report;
        var courseStructureType = this.getCourseStructureType(report.id);
        stmts.filter(function (stmt) {
            var display = stmt.verb.display;
            return reportUtils.isDesiredVerb(display);
        }).forEach(function (stmt) {
            try {
                var actor = stmt.actor;
                var user = reportUtils.getUser(actor);
                var userData = userMap[user.id] || reportUtils.createUserData.bind(_this)(user, courseStructureType);
                var stmtData = afirm.getTotalsData[courseStructureType](stmt);
                if (!stmtData) {
                    return;
                }
                if (stmtData.prop === 'completedAt') {
                    userData.completedAtDate = new Date(stmtData.value).toLocaleDateString();
                    userData.completedAtTime = new Date(stmtData.value).toLocaleTimeString();
                }
                else {
                    if (userData[stmtData.prop]) {
                        userData[stmtData.prop].dataMap[stmtData.activity] = stmtData.value;
                    }
                }
                userMap[user.id] = userData;
            }
            catch (error) {
                console.error('error processing totals:', error);
            }
        });
        return afirm.getTotals(userMap);
    },
    getCourseStructureType: function (id) {
        return this.courseTypeMap[id] ? this.courseTypeMap[id].type : '';
    },
    // getCourseStructureType(id: string) {
    // 	let structureType = '';
    // 	for (const courseType in this.courseTypeMap) {
    // 		const typeList = this.courseTypeMap[courseType];
    // 		const typeCourseIdList = typeList.map((course: any) => {
    // 			return Object.keys(course);
    // 		});
    // 		if (typeCourseIdList.includes(id)) {
    // 			structureType = courseType;
    // 		}
    // 	}
    // 	return structureType;
    // },
    allValues: function (stmts) {
        var _this = this;
        console.log('stmts:', stmts);
        try {
            var options = new DynamicTableOptions();
            options.showScoresOnly = true;
            options.showCompletion = true;
            // options.useNameAndDescHeaders = $('#showDescHeader')[0].checked;
            // afirm.useNameAndDescHeaders = options.useNameAndDescHeaders
            options.useNameAndDescHeaders = afirm.useNameAndDescHeaders;
            var dynamicTableData_1 = dynamicTable.init(stmts, options);
            console.log('dynamicTableData:', dynamicTableData_1);
            ['colHeaders', 'colDataStructure'].forEach(function (prop) {
                // this[prop][this.report.id].allValues = dynamicTableData[prop];
                var courseStructureType = _this.getCourseStructureType(_this.report.id);
                _this[prop][courseStructureType].allValues = dynamicTableData_1[prop];
            });
            return dynamicTableData_1.tableData;
        }
        catch (error) {
            console.error('allValues error:', error);
        }
        return [];
    },
    checkIfCompletedStmt: function (display, timestamp) {
        var displayValues = Object.values(display);
        var isComplete = displayValues.includes('completed');
        if (isComplete) {
            return {
                prop: 'completedAt',
                value: timestamp,
            };
        }
        return false;
    },
    getTotalsData: {
        type1: function (stmt) {
            var result = stmt.result, verb = stmt.verb, target = stmt.target, timestamp = stmt.timestamp;
            var display = verb.display;
            var completionData = afirm.checkIfCompletedStmt(display, timestamp);
            if (completionData) {
                return completionData;
            }
            var actName = target.definition.name['en-US'];
            var isTeacher = actName.includes('teacher');
            var isStudent = actName.includes('student');
            var isTask = actName.includes('task');
            var isPreTest = actName.includes('pre-test');
            var isPostTest = actName.includes('post-test');
            var isSummary = actName.includes('summary');
            // TODO: use summary instead of rollup for Totals?
            if (isSummary) {
                return;
            }
            // const isPreSummary = isSummary && actName.includes('all pre');
            // const isPostSummary = isSummary && actName.includes('all post');
            // Pre and Post
            var isStudentPreTest = isStudent && isPreTest;
            var isStudentPostTest = isStudent && isPostTest;
            var isTeacherPreTest = isTeacher && isPreTest;
            var isTeacherPostTest = isTeacher && isPostTest;
            var isTaskPreTest = isTask && isPreTest;
            var isTaskPostTest = isTask && isPostTest;
            // Pre and Post Summaries
            // const isStudentPreSummary = isStudent && isPreSummary;
            // const isStudentPostSummary = isStudent && isPostSummary;
            // const isTeacherPreSummary = isTeacher && isPreSummary;
            // const isTeacherPostSummary = isTeacher && isPostSummary;
            // const isTaskPreSummary = isTask && isPreSummary;
            // const isTaskPostSummary = isTask && isPostSummary;
            var returnProp = function () {
                return isStudentPreTest ? 'preStudent' :
                    isTeacherPreTest ? 'preTeacher' :
                        isTaskPreTest ? 'preTask' :
                            isStudentPostTest ? 'postStudent' :
                                isTeacherPostTest ? 'postTeacher' :
                                    isTaskPostTest ? 'postTask' :
                                        '';
            };
            return {
                prop: 'score_' + returnProp(),
                activity: actName,
                value: result.score.raw,
            };
        },
        type2: function (stmt) {
            var result = stmt.result, verb = stmt.verb, target = stmt.target, timestamp = stmt.timestamp;
            var display = verb.display;
            var completionData = afirm.checkIfCompletedStmt(display, timestamp);
            if (completionData) {
                return completionData;
            }
            var actName = target.definition.name['en-US'];
            var activityMap = [
                {
                    text: 'Plan: General',
                    column: 'score_planGeneral'
                },
                {
                    text: 'Plan: EBP',
                    column: 'score_planEbp'
                },
                {
                    text: 'Use: Basic',
                    column: 'score_useRules'
                },
                {
                    text: 'Use: Steps',
                    column: 'score_useSteps'
                },
                {
                    text: 'Monitor: Data',
                    column: 'score_monitorData'
                },
                {
                    text: 'Monitor: Next',
                    column: 'score_monitorSteps'
                },
            ];
            var returnProp = activityMap.reduce(function (accum, current) {
                if (actName.includes(current.text)) {
                    accum.push(current.column);
                }
                return accum;
            }, []);
            return {
                prop: returnProp[0],
                activity: actName,
                value: result.score.raw,
            };
        },
    },
    getTotals: function (userMap) {
        var finalTotalList = [];
        for (var user in userMap) {
            var userData = userMap[user];
            var rowData = JSON.parse(JSON.stringify(userData));
            for (var prop in userData) {
                var activityMetrics = userData[prop];
                if (prop.startsWith('score_')) {
                    var dataMap = activityMetrics.dataMap;
                    for (var activity in dataMap) {
                        var value = dataMap[activity];
                        activityMetrics.total += value;
                    }
                }
            }
            for (var dataProp in userData) {
                if (dataProp.startsWith('score_')) {
                    rowData[dataProp] = userData[dataProp].total;
                }
            }
            // TEMP
            rowData.maxScore = 44;
            finalTotalList.push(rowData);
        }
        // // Add totals row
        // finalTotalList.push({});
        return finalTotalList;
    },
};
